/** 포토후기 작성 시 웰포인트 혜택 금액 */
export const PHOTO_REVIEW_BENEFIT_AMOUNT = 1_000;
